// @ts-strict-ignore
import {Component, DoCheck, EventEmitter, Input, KeyValueDiffer, KeyValueDiffers, OnInit, output} from "@angular/core";
import {CameraLayoutOption, CameraLayoutOptionsContainer, CameraLayoutType, CameraViewMode, WebCameraView} from "@models";
import {SimCameraService, SimUtilityService} from "@services";
import {EventEmitterService} from "@event-emitter";

@Component({
	selector: "sim-base-camera-layout",
	templateUrl: "./recorder-layout.component.html",
	styleUrls: ["./recorder-layout.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class BaseCameraLayout implements OnInit, DoCheck {
	CameraLayoutType = CameraLayoutType;
	CameraViewMode = CameraViewMode;

	@Input() isPipEditable = false;
	pipLayoutOptionsChanged = output<CameraLayoutOption>();

	@Input() isTwoScreen: boolean;
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	public cameraLayout: CameraLayoutType;

	private differ: KeyValueDiffer<any, any> = null;

	constructor(
		private differs: KeyValueDiffers,
		private _emitterService: EventEmitterService,
		private _simCameraService: SimCameraService,
	) {}

	public ngOnInit() {
		this.differ = this.differs.find(this.cameraLayoutOptionsContainer.options).create();

		this._emitterService.onCameraSettingsChanged.subscribe(async (args) => {
			// TODO: this is a hack to get the camera to update when the camera settings are changed.
			// should be refactored by removing the `cameras` property from the layout options and directly
			// querying the cameras from the camera service

			const screens: WebCameraView[] = [];

			for (let screen of this.cameraLayoutOptionsContainer.options.screens as WebCameraView[]) {
				if (screen.id === args.cameraId) {
					const updatedCamera = await this._simCameraService.getCameraById(args.cameraId);
					screens.push(updatedCamera);
					SimUtilityService.copy(updatedCamera, screen);
				} else {
					screens.push(screen);
				}
			}

			this.cameraLayoutOptionsContainer.options.screens = screens;
		});
	}

	public ngDoCheck() {
		const changes = this.differ.diff(this.cameraLayoutOptionsContainer.options);

		if (changes) {
			changes.forEachChangedItem((keyValueChangeRecord) => {
				console.debug("changed: " + keyValueChangeRecord.key);
			});
		}
	}
}
